export class ToolColumn {
  constructor(
    public field: string,
    public headerTitle: string,
    public show: boolean = true,
    public filter: string = "string",
    public pinned?: boolean,
    public sortable: boolean = true,
  ) {}
}
